import React from 'react';
import Layout from '../../src/components/Layout/Layout';
import PrivacyPolicy from '../../src/components/PrivacyPolicy/PrivacyPolicy';

const Privacy = () => (
  <Layout>
    <PrivacyPolicy />
  </Layout>
);

export default Privacy;
